/**
 * Boot state — the little bit of app-startup status the first-boot loading
 * screen needs to know when it's safe to get out of the way.
 *
 * Right now that's one signal: has the map finished its initial load? MapView
 * fires MapLibre's 'load' once (style parsed, first frame rendered), and sets
 * this true there. The loading overlay pairs that with "do we have a position
 * fix yet" (read from the chart-plotter store) to decide when to dismiss, with
 * a timeout as a backstop so it can never hang.
 */
import { create } from 'zustand';

interface BootState {
  /** True once the map's initial 'load' has fired (base style is up). */
  mapReady: boolean;
  setMapReady: () => void;
}

export const useBootStore = create<BootState>((set) => ({
  mapReady: false,
  setMapReady: () => set({ mapReady: true }),
}));
